module.exports = __webpack_public_path__ + "static/media/remember-me-box-selected.acda4086.svg";